/* eslint-disable */
import { makeStyles } from "@mui/styles";
export const useAutoCompleteInput = makeStyles({
    input: {
        width: "100%",
        border: "1px solid #E8E8E8",
        height: "50px",
        borderRadius: "5px",
        "& .MuiInputBase-input": {
            padding: "15px 0px 15px 16px",
        },
    },
    placeholder: {
        color: "#C2CFE0",
        textOverflow: "ellipsis",
        overflow: "hidden",
    },
    select: {
        width: "100%",
        "& .MuiFormControl-root > .MuiOutlinedInput-root": {
            fontSize: "14px",
            fontWeight: "normal",
            height: "50px",
            "& .MuiOutlinedInput-input::placeholder": {
                color: "rgba(194, 207, 224, 1)",
                opacity: 1,
            },
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#E8E8E8",
                "& > legend": {
                    width: 0,
                },
            },
        },
    },
    formControl: {
        width: "100%",
    },
    label: {
        marginBottom: "11px",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "14px",
        lineHeight: "16px",
        padding: 0,
        textOverflow: "ellipsis",
        overflow: "hidden",
        ["@media screen and (max-width: 1280px)"]: {
            fontSize: "11px",
        },
    },
    inputError: {
        width: "100%",
        border: "1px solid #f7685b",
        height: "50px",
        borderRadius: "5px",
        "& .MuiInputBase-input": {
            padding: "15px 0px 15px 20px",
        },
    },
    hiddenIt: {
        display: "none",
    },
    labelError: {
        color: "#f7685b",
        fontSize: "12px",
        display: "flex",
        marginTop: "5px",
    },
    iconError: {
        fontSize: "14px",
        position: "relative",
        top: "2px",
        marginRight: "8px",
    },
});
